import MaintenanceMode from './MaintenanceScreen.jsx';

export default MaintenanceMode;